<div class="statement-content-container h-full w-full">
  <div class="statement-content-wrapper h-full w-full">
    <df-statement-steps></df-statement-steps>
    <ng-content></ng-content>
  </div>
</div>
